module.exports = __webpack_public_path__ + "media/images/responsive/page_common/noimage/square/deco_white-fc54eadcd5a603d2a0dfe725d16919dc.png";